<div class="row">
  <div class="display-flax justify-content-between py-2" hidden>
    <div class="stat-left">
      <div class="label-text">Stats overview for :</div>
      <div class="stat-select mx-3">
        <select class="form-select form-select-sm">
          <option class="text-option" selected disabled>Select Duration</option>
          <option value="1">Yesterday</option>
          <option value="2">Current Week</option>
          <option value="3">Last Week</option>
          <option value="3">Last month</option>
        </select>
      </div>
    </div>
    <div class="stat-right">
      <div class="lebel-text-right">View detailed stats</div>
    </div>
  </div>

  <!-- <div class="display-flax my-2" hidden>
  <div class="stat-container">
      @for (stat of stats; track stat.name) {
      <div class="stat">
          <div class="stat-header-info">
              <div class="stat-name"> {{stat.name}} </div>
              @if (!stat.isDisplayRating) {
                  <div class="sales-count"> {{stat.salesCount}} Sales</div>
              } @else {
                  <div class="sales-count"> {{stat.rating}} Rating</div>
              }
          </div>
          <div class="stat-body">
              <div class="stat-image-wrapper">
                  <img class="stat-image" [src]="stat.menuImg" />
              </div>
              <div class="stat-menu-name">
              {{stat.menuName}}
              </div>
          </div>
      </div>
      }
</div>
</div> -->

  <div class="display-flax my-2 pl-4 pr-4">
    <div class="fnf-segmented" role="tablist">
      <button
        type="button"
        class="fnf-segment"
        [class.fnf-segment--active]="selectedStatus === 'published'"
        (click)="getMenusByStatus('published')"
      >
        Published
      </button>
      <button
        type="button"
        class="fnf-segment"
        [class.fnf-segment--active]="selectedStatus === 'draft'"
        (click)="getMenusByStatus('draft')"
      >
        Draft
      </button>
      <button
        type="button"
        class="fnf-segment"
        [class.fnf-segment--active]="selectedStatus === 'archived'"
        (click)="getMenusByStatus('archived')"
      >
        Trash
      </button>
    </div>
  </div>

  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading menus, please wait...</p>
      </div>
    </div>
  } @else {
    @if (menusOriginal?.length > 0) {
      <!-- <div class="display-flax justify-content-between align-baseline py-1" >
  <div class="btn-group">
      <button class="btn dropdown-toggle btn-category border-0" type="button" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
          {{ selectedOption || 'Select Category' }}
      </button>
      <ul class="dropdown-menu">
          @for (option of options; track option) {
              <li><a class="dropdown-item type-option"  (click)="onSelect(option)">{{ option.name }}</a></li>
          }
      </ul>
    </div>
</div> -->
      <div class="dropdown">
        <button
          class="btn dropdown-toggle rounded-5 btn-lg"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ selectedOption }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          @for (option of options; track option; let i = $index) {
            <li (click)="onSelect(option)">
              <a class="dropdown-item">{{ option.name }}</a>
            </li>
          }
        </ul>
      </div>
    }

    @if (menusOriginal?.length > 0 && selectedOptionId) {
      <div class="display-flax justify-content-start align-baseline py-2 my-2 pl-4 pr-4">
        <div class="category-list">
          @for (category of allCategories; track category.id) {
            <!-- <button type="button" class="btn btn-category-item">
              {{category.name}} 
              <span class="badge text-bg-light badge-category-count">{{category.count}}</span>
          </button> -->
            <div
              class="type-category mr-2"
              [ngClass]="{
                'category-active': category.isActive,
                'custom-label-active': category.isActive,
              }"
              (click)="onCategorySelect(category)"
            >
              <div class="category-name" [ngClass]="{ 'category-active': category.isActive }">
                {{ category.name }}
              </div>
              <div class="category-count" [ngClass]="{ 'category-active': category.isActive }">
                {{ category.count }}
              </div>
            </div>
          }
          <!-- <button type="button" class="btn btn-category-item opacity-50">
          <b>+</b> Add Category 
      </button> -->
        </div>
      </div>

      <div class="row pl-4 pr-0">
        <div class="col-12">
          <input
            type="text"
            class="form-control"
            [value]="searchText"
            placeholder="Search Menus by name"
            (input)="searchMenus($event)"
          />
        </div>
      </div>

      <div class="justify-content-start align-baseline py-2 my-2 pl-4 pr-4">
        <div class="sorting-pagination">
          <div class="pagination">
            <div class="results-per-page d-none">
              <div class="per-page">Per page:</div>
              <div class="dropdown">
                <button
                  class="btn dropdown-toggle bg-white rounded-5"
                  type="button"
                  id="dropdownMenuButton2"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ itemsPerPage }} items
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                  @for (option of [10, 20, 50, 100]; track option; let i = $index) {
                    <li (click)="changeItemsPerPage(option)">
                      <a class="dropdown-item">{{ option }}</a>
                    </li>
                  }
                </ul>
              </div>
            </div>
            <div class="bullet d-none"></div>
            <div class="page-2-of-6 d-none">
              <span>
                <span class="page-2-of-6-span">Page</span>
                <span class="page-2-of-6-span2 pl-2 pr-2">{{ currentPage }}</span>
                <span class="page-2-of-6-span3">of</span>
                <span class="page-2-of-6-span4 pl-2 pr-2">{{ totalPages }}</span>
              </span>
            </div>
            <div class="navigation d-none">
              <button
                class="btn nav-button"
                [disabled]="currentPage === 1"
                (click)="changePage(currentPage - 1)"
              >
                <i class="bx bx-chevron-left"></i>
              </button>
              <button
                class="btn nav-button"
                [disabled]="currentPage === totalPages"
                (click)="changePage(currentPage + 1)"
              >
                <i class="bx bx-chevron-right"></i>
              </button>
            </div>
          </div>
          <div class="right">
            <div class="view-as">
              <div class="view-as2">View as:</div>
              <div class="dropdown">
                <button
                  class="btn dropdown-toggle bg-white rounded-5"
                  type="button"
                  id="dropdownMenuButton3"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ defaultView }}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
                  @for (option of ['Large Grid', 'Table']; track option; let i = $index) {
                    <li (click)="changeMenuView(option)">
                      <a class="dropdown-item">{{ option }}</a>
                    </li>
                  }
                </ul>
              </div>
              <div class="button d-none">
                <div class="large-grid">Large Grid</div>
                <div class="icon">
                  <div class="arrow-down">
                    <!-- <img class="arrow-down-012" src="arrow-down-011.svg" /> -->
                  </div>
                </div>
                <!-- <img class="underline2" src="underline1.svg" /> -->
              </div>
            </div>
            <div class="sort-by d-none">
              <div class="sort-by2">Sort by:</div>
              <div class="button">
                <div class="price-high-to-low">Price - high to low</div>
                <div class="icon">
                  <div class="arrow-down">
                    <!-- <img class="arrow-down-013" src="arrow-down-012.svg" /> -->
                  </div>
                </div>
                <!-- <img class="underline3" src="underline2.svg" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (menusOriginal?.length == 0) {
      @if (
        selectedStatus == 'published' || selectedStatus == 'draft' || selectedStatus == 'archived'
      ) {
        <div
          class="d-flex flex-column align-items-center justify-content-center common-empty-container"
        >
          <img src="assets/empty-menu.png" alt="No Devices" class="common-empty-img mb-3" />
          <p class="common-empty-header">No Menu Items Available</p>
          <p class="common-empty-sub-text">
            There are no menu items to display right now. They’ll show up here once added.
          </p>
        </div>
      }
    }

    @if (defaultView == 'Large Grid') {
      <div class="display-flax justify-content-start align-baseline my-2 mt-4 pl-4 pr-4">
        <div class="menu-list">
          @if (paginatedItems.length > 0) {
            @for (menu of paginatedItems; track menu.menu_id) {
              <div class="menu-item">
                <div class="image">
                  @if (menu.image_url) {
                    <img
                      class="image2 w-100"
                      [src]="menu.image_url"
                      (error)="onImageError($event)"
                      (dblclick)="editMenu(menu)"
                      [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                    />
                  } @else {
                    <img
                      class="image2 object-fit-cover"
                      src="./../../../../assets/default/nomenu.png"
                      (dblclick)="editMenu(menu)"
                    />
                  }
                  <!-- <img class="image2" [src]="menu.image_url" /> -->
                  <!-- <div class="overlay"></div>
                    <div class="offer" *ngIf="false">
                      <div class="_25-off-today">25% OFF - Today</div>
                      <img class="right-part" src="right-part0.svg" />
                      <img class="left-bottom-part" src="left-bottom-part0.svg" />
                    </div> -->
                  <div class="top-right edit-wrapper">
                    <div class="btn-group custom-dropdown1">
                      <button
                        type="button"
                        class="btn bg-white dropdown-toggle pl-1 pr-1 rounded-2 edit-dropdown-btn"
                        data-bs-toggle="dropdown"
                        data-bs-display="static"
                        aria-expanded="false"
                      >
                        <i class="bx bx-dots-vertical"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-lg-end custom-dropdown-menu">
                        <li>
                          <a class="dropdown-item type-option" (click)="editMenu(menu)">
                            <span class="mr-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M9.38251 2.59046C9.87931 2.05222 10.1277 1.7831 10.3916 1.62612C11.0285 1.24734 11.8128 1.23556 12.4603 1.59504C12.7286 1.74403 12.9846 2.00558 13.4967 2.52867C14.0088 3.05176 14.2648 3.31331 14.4106 3.58745C14.7626 4.24891 14.751 5.05002 14.3802 5.70063C14.2266 5.97027 13.9631 6.22402 13.4362 6.7315L7.16711 12.7697C6.16863 13.7314 5.66938 14.2123 5.04542 14.456C4.42145 14.6997 3.73551 14.6818 2.36361 14.6459L2.17696 14.641C1.75931 14.6301 1.55049 14.6246 1.4291 14.4868C1.30771 14.3491 1.32428 14.1364 1.35743 13.711L1.37543 13.48C1.46871 12.2825 1.51535 11.6838 1.74918 11.1456C1.983 10.6074 2.38633 10.1705 3.19299 9.2965L9.38251 2.59046Z"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.66663 2.6665L13.3333 7.33317"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.33337 14.6665H14.6667"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg> </span
                            >Edit menu
                          </a>
                        </li>
                        <li class="custom-line-top p-1"></li>
                        <li>
                          <div class="switch ml-3 mb-3 d-flex gap-4">
                            <div class="form-check form-switch ml-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                [checked]="menu.is_available"
                                [disabled]="isPosManaged"
                                (change)="toggleMenuAvailability(menu, $event)"
                              />
                            </div>
                            <span class="pt-1">Mark As Available</span>
                          </div>
                        </li>

                        @if (selectedStatus != 'archived' && !isPosManaged) {
                          <li class="custom-line-top p-1"></li>
                          <li>
                            <a
                              class="dropdown-item type-option delete-dropdown-item text-primary"
                              (click)="deleteMenu(menu)"
                            >
                              <i class="bx bx-trash mr-2"></i> Delete menu
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                  <div
                    class="unavailable-wrapper justify-content-center"
                    [ngStyle]="{ display: menu.is_available ? 'none' : 'block' }"
                  >
                    <div class="unavailable-text">
                      <span class="unavailable-text-span">Unavailable</span>
                    </div>
                  </div>
                </div>
                <div
                  class="body"
                  (dblclick)="editMenu(menu)"
                  matTooltip="Double click to edit the menu"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  <div class="price-indications">
                    <div class="price">
                      <div class="_16-50-22-00">
                        <span>
                          <!-- <span class="_16-50-22-00-span"> {{menu.currency}} </span> -->
                          <span class="_16-50-22-00-span"> $ </span>
                          <span class="_16-50-22-00-span2">
                            {{ menu.price | number: '1.2-2' }}
                          </span>
                          <span class="_16-50-22-00-span3"> {{ menu.promotion_price }} </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="title-description">
                    <div class="creamy-garlic-mushroom-chicken-with-mashed-potatoes">
                      {{ menu.name }}
                    </div>
                    <div class="a-potato-dish-made-with-boiled-potatoes-in-a-spicy-gravy">
                      {{ menu.description }}
                    </div>
                  </div>
                </div>
                <div
                  class="categories"
                  (dblclick)="editMenu(menu)"
                  matTooltip="Double click to edit the menu"
                >
                  @for (category of menu.categories; track category) {
                    <div class="category">
                      <div class="lunch">{{ category }}</div>
                    </div>
                  }
                  <!-- <div class="category">
                      <div class="lunch">Lunch</div>
                    </div>
                    <div class="category2">
                      <div class="dinner">Dinner</div>
                    </div> -->
                </div>
                <br />
                <!-- <div class="actions w-100">
                    <div class="btn btn-sm btn-danger" (click)="deleteMenu(menu)" >
                      Delete
                    </div>
                    <div class="btn btn-sm btn-warning" (click)="editMenu(menu)" >
                      Edit
                    </div>
                  </div> -->
              </div>
            }
          }
          @if (paginatedItems.length == 0 && searchText.length > 0) {
            <div class="text-center m-auto">
              <img src="assets/empty-menu.png" alt="No Devices" class="common-empty-img mb-3" />
              <p class="common-empty-header">No Search Menu Items Available</p>
            </div>
          }
          @if (
            paginatedItems.length == 0 && selectedCategoryCount == 0 && menusOriginal?.length > 0
          ) {
            <div class="text-center m-auto">
              <img src="assets/empty-menu.png" alt="No Devices" class="common-empty-img mb-3" />
              <p class="common-empty-header">Selected Category is Empty</p>
              <p class="common-empty-sub-text">
                There are no menu items to display right now. They’ll show up here once added.
              </p>
            </div>
          }

          <!-- @for (menu of menus; track menu.menu_id) {
            <div class="menu-item"  [ngStyle]="{'max-width': isSidebarExpanded ? '296px' : '260px' }" >
                <div class="image">
                  <img class="image2" [src]="menu.image_url" />
                  <div class="overlay"></div>
                  <div class="offer">
                    <div class="_25-off-today">25% OFF - Today</div>
                    <img class="right-part" src="right-part0.svg" />
                    <img class="left-bottom-part" src="left-bottom-part0.svg" />
                  </div>
                </div>
                <div class="body">
                  <div class="price-indications">
                    <div class="price">
                      <div class="_16-50-22-00">
                        <span>
                          <span class="_16-50-22-00-span">$</span>
                          <span class="_16-50-22-00-span2">16.50</span>
                          <span class="_16-50-22-00-span3">$22.00</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="title-description">
                    <div class="creamy-garlic-mushroom-chicken-with-mashed-potatoes">
                      Creamy Garlic Mushroom Chicken with Mashed Potatoes
                    </div>
                    <div class="a-potato-dish-made-with-boiled-potatoes-in-a-spicy-gravy">
                      A potato dish made with boiled potatoes in a spicy gravy.
                    </div>
                  </div>
                </div>
                <div class="categories">
                  <div class="category">
                    <div class="lunch">Lunch</div>
                  </div>
                  <div class="category2">
                    <div class="dinner">Dinner</div>
                  </div>
                </div>
              </div>
        }

        @for (menu of menus; track menu.menu_id) {
            <div class="menu-item"  [ngStyle]="{'max-width': isSidebarExpanded ? '296px' : '260px' }">
                <div class="image">
                  <img class="image2" [src]="menu.image_url" />
                  <div class="overlay"></div>
                  <div class="offer">
                    <div class="_25-off-today">25% OFF - Today</div>
                    <img class="right-part" src="right-part0.svg" />
                    <img class="left-bottom-part" src="left-bottom-part0.svg" />
                  </div>
                </div>
                <div class="body">
                  <div class="price-indications">
                    <div class="price">
                      <div class="_16-50-22-00">
                        <span>
                          <span class="_16-50-22-00-span">$</span>
                          <span class="_16-50-22-00-span2">16.50</span>
                          <span class="_16-50-22-00-span3">$22.00</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="title-description">
                    <div class="creamy-garlic-mushroom-chicken-with-mashed-potatoes">
                      Creamy Garlic Mushroom Chicken with Mashed Potatoes
                    </div>
                    <div class="a-potato-dish-made-with-boiled-potatoes-in-a-spicy-gravy">
                      A potato dish made with boiled potatoes in a spicy gravy.
                    </div>
                  </div>
                </div>
                <div class="categories">
                  <div class="category">
                    <div class="lunch">Lunch</div>
                  </div>
                  <div class="category2">
                    <div class="dinner">Dinner</div>
                  </div>
                </div>
              </div>
        }  -->
        </div>
      </div>
    }
    @if (defaultView == 'Table' && paginatedItems.length > 0) {
      <div class="display-flax justify-content-start align-baseline my-2 mt-4">
        <table class="table text-left">
          <thead class="table-light">
            <tr class="bg-dark">
              <th scope="col">
                <input
                  class="form-check-input position-relative ml-0"
                  type="checkbox"
                  [checked]="isCheckAllMenu"
                  (change)="onAllMenuCheckboxChange($event)"
                />
              </th>
              <th scope="col">Avatar</th>
              <th scope="col">SKU</th>
              <th scope="col w-25">Name</th>
              <th scope="col">Price</th>
              <th scope="col">Category</th>
              <th scope="col">Station</th>
              <th scope="col">Stock Status</th>
              <!-- <th scope="col">Promotion</th> -->
              <th scope="col">Actions</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            @for (menu of paginatedItems; track menu.menu_id; let i = $index) {
              <tr class="border-left border-right">
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  <input
                    class="form-check-input position-relative ml-0"
                    type="checkbox"
                    [checked]="menu.isSelected"
                    (change)="onMenuCheckboxChange($event, menu, i)"
                  />
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  @if (menu.image_url) {
                    <!-- Any aspect ratio: the photo fits whole, and a blurred copy
                         fills the rest of the 3:2 box instead of stretching it. -->
                    <span class="image-table" (dblclick)="editMenu(menu)">
                      <img
                        class="image-table-fill"
                        [src]="menu.image_url"
                        alt=""
                        aria-hidden="true"
                        (error)="$any($event.target).style.display = 'none'"
                      />
                      <img
                        class="image-table-photo"
                        [src]="menu.image_url"
                        [alt]="menu.name || ''"
                        (error)="onImageError($event)"
                      />
                    </span>
                  } @else {
                    <img
                      class="image-table-empty"
                      src="./../../../../assets/default/nomenu.png"
                      (dblclick)="editMenu(menu)"
                    />
                  }
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  {{ menu.sku }}
                </td>
                <td
                  class="w-25"
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  {{ menu.name }}
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  $ {{ menu.price | number: '1.2-2' }}
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  @for (category of menu.categories; track category) {
                    <div class="category mb-1 justify-content-center rounded-5">
                      <div class="lunch">{{ category }}</div>
                    </div>
                  }
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  {{ menu.stationName ? menu.stationName : 'N/A' }}
                </td>
                <td
                  [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''"
                  [ngStyle]="{ opacity: menu.is_available ? '1' : '0.3' }"
                >
                  @if (menu.is_available) {
                    <span class="inStock">In Stock</span>
                  } @else {
                    <span class="outStock">Out Stock</span>
                  }
                  <!-- {{menu.is_available ? 'In Stock' : 'Out Stock'}} -->
                </td>
                <!-- <td [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''">{{menu.promotion}}</td> -->
                <td class="overflow-visible" [ngClass]="menu.isSelected ? 'bg-danger-subtle' : ''">
                  <div class="btn-group custom-dropdown1">
                    <button
                      type="button"
                      class="btn bg-white dropdown-toggle pl-2 pr-2 border"
                      data-bs-toggle="dropdown"
                      data-bs-display="static"
                      aria-expanded="false"
                    >
                      <i class="bx bx-dots-vertical"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-lg-end custom-dropdown-menu">
                      @if (
                        (isSelectedMenuCount > 1 && menu.isSelected) ||
                        isSelectedMenuCount == paginatedItems.length
                      ) {
                        <li>
                          <a class="dropdown-item type-option" (click)="quickEditMenu(true)">
                            <i class="bx bx-rocket mr-2"></i> Quick Edit
                          </a>
                        </li>
                      }
                      @if (!menu.isSelected || (menu.isSelected && isSelectedMenuCount == 1)) {
                        <li>
                          <a class="dropdown-item type-option" (click)="editMenu(menu)">
                            <span class="mr-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M9.38251 2.59046C9.87931 2.05222 10.1277 1.7831 10.3916 1.62612C11.0285 1.24734 11.8128 1.23556 12.4603 1.59504C12.7286 1.74403 12.9846 2.00558 13.4967 2.52867C14.0088 3.05176 14.2648 3.31331 14.4106 3.58745C14.7626 4.24891 14.751 5.05002 14.3802 5.70063C14.2266 5.97027 13.9631 6.22402 13.4362 6.7315L7.16711 12.7697C6.16863 13.7314 5.66938 14.2123 5.04542 14.456C4.42145 14.6997 3.73551 14.6818 2.36361 14.6459L2.17696 14.641C1.75931 14.6301 1.55049 14.6246 1.4291 14.4868C1.30771 14.3491 1.32428 14.1364 1.35743 13.711L1.37543 13.48C1.46871 12.2825 1.51535 11.6838 1.74918 11.1456C1.983 10.6074 2.38633 10.1705 3.19299 9.2965L9.38251 2.59046Z"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M8.66663 2.6665L13.3333 7.33317"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.33337 14.6665H14.6667"
                                  stroke="#98A0AE"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg> </span
                            >Edit Menu
                          </a>
                        </li>
                        <li class="custom-line-top p-1"></li>
                        <li>
                          <div class="switch ml-3 mb-3 d-flex gap-4">
                            <div class="form-check form-switch ml-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                [checked]="menu.is_available"
                                [disabled]="isPosManaged"
                                (change)="toggleMenuAvailability(menu, $event)"
                              />
                            </div>
                            <span class="pt-1">Mark As Available</span>
                          </div>
                        </li>
                        @if (selectedStatus != 'archived' && !isPosManaged) {
                          <li class="custom-line-top p-1"></li>
                          <li>
                            <a
                              class="dropdown-item type-option delete-dropdown-item text-primary"
                              (click)="deleteMenu(menu)"
                            >
                              <i class="bx bx-trash mr-2"></i> Delete Menu
                            </a>
                          </li>
                        }
                      }
                    </ul>
                  </div>
                </td>
                <td>
                  <span [ngStyle]="{ display: menu.is_available ? 'none' : 'block' }">
                    <i class="bx bx-block bx-xs text-danger"></i>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>

        @if (showSelectAllActions) {
          <div
            class="toast-container position-fixed bottom-0 p-3 custom-toaster justify-content-around"
          >
            <div>
              <p class="text-white pt-2">{{ isSelectedMenuCount }} Items selected</p>
            </div>
            <!-- <div>
          <i class="bx bx-trash text-white"></i>
        </div> -->
            <div>
              <button
                class="btn btn-outline-light"
                [disabled]="isPosManaged"
                (click)="stockChange(true)"
              >
                In Stock
              </button>
            </div>
            <div>
              <button
                class="btn btn-outline-primary"
                [disabled]="isPosManaged"
                (click)="stockChange(false)"
              >
                Out Stock
              </button>
            </div>
            <div>
              <p class="text-white pt-4 cancelToaster" (click)="quickEditMenu(false)">Cancel</p>
              >
            </div>
          </div>
        }
      </div>
    }
  }
</div>
